import {Grid, Hide, Show} from 'platform/foundation';

import {isNil} from 'ramda';

import {useGetParticipationQuery} from '@dms/api/core';
import {useGetVehicleQuery} from '@dms/api/sales';
import {EntityResourceIds} from '@dms/api/shared';
import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {CommentsWidget, RestrictedArea, usePermissions} from '@dms/shared';

interface BusinessCaseSaleVehicleCommentsProps {
  vehicleId?: string;
}

export function BusinessCaseSaleVehicleComments(props: BusinessCaseSaleVehicleCommentsProps) {
  const {data: vehicleParticipation} = useGetParticipationQuery(
    {
      resourceId: EntityResourceIds.vehicle,
      recordId: props.vehicleId ?? '',
    },
    {skip: isNil(props.vehicleId)}
  );

  const {data: vehicleData} = useGetVehicleQuery(
    {vehicleId: props.vehicleId ?? ''},
    {skip: isNil(props.vehicleId)}
  );

  const [
    hasVehicleCommentReadPermission,
    hasVehicleCommentAddPermission,
    hasVehicleCommentDeletePermission,
  ] = usePermissions({
    permissionKeys: ['vehicleCommentRead', 'vehicleCommentAdd', 'vehicleCommentDelete'],
    scopes: {
      vehicleCommentAdd: {
        participation: vehicleParticipation,
        branchId: vehicleData?.branchId,
      },
      vehicleCommentRead: {
        participation: vehicleParticipation,
        branchId: vehicleData?.branchId,
      },
      vehicleCommentDelete: {
        participation: vehicleParticipation,
        branchId: vehicleData?.branchId,
      },
    },
  });

  if (isNil(props.vehicleId)) {
    return null;
  }

  return (
    <Grid columns={[1, 2]}>
      <Hide when={hasVehicleCommentReadPermission}>
        <RestrictedArea shouldHideRedirectButton />
      </Hide>
      <Show when={hasVehicleCommentReadPermission}>
        <CommentsWidget
          cardVariant="inlineWhite"
          title={i18n.t('entity.vehicle.labels.vehicleComments')}
          resourceId={EntityResourceIds.vehicle}
          recordId={props.vehicleId}
          isAddDisabled={!hasVehicleCommentAddPermission}
          isDeleteDisabled={!hasVehicleCommentDeletePermission}
          data-testid={testIds.businessCase.buying('commentsWidget')}
        />
      </Show>
    </Grid>
  );
}
